import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { EmployeeWidget } from '@/widgets/employee-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.names': z.array(z.string()).optional(),
  'filter.positions': z.array(z.string()).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'filter.tenantIds': z.array(z.string()).optional(),
  'filter.active': z.boolean().optional(),
  'filter.fio': z.string().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/users/employees')({
  staticData: {
    meta: {
      title: 'Сотрудники',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.EMPLOYEES}>
      <PageWrapper title={t('Сотрудники')}>
        <EmployeeWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
